import { Form } from "./Components/Form";

function App() {

  return (
    <div className="glass">
      <div className="wrapper">
        <h3 className="heading">TODO-APP </h3>
        <div className="form-and-todo-box">
          <Form />
        </div>
      </div>
    </div>
  );
}

export default App;
